export default "__VITE_ASSET__fhoOdegO__"